import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IPagedData, PagedCrudService } from "@features/grid";
import { MessageService } from "primeng/api";
import { SharedFile } from "@mipro/custom-controls/shared-file";
import { UserSuggestion } from "@project/models";
import { IQueryCommand, StringFilter, StringFilterMatchMode } from "@features/filter";

@Injectable({
    providedIn: "root"
})
export class SharedFileService extends PagedCrudService<SharedFile> {
    readonly url = "api/shared-files";
    entityTitle = "Shared File";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory, protected messageService: MessageService) {
        super(http, handlersFactory);
    }

    getUsersPage(filters: {searchTerm: string, field: string}[]): Promise<IPagedData<UserSuggestion>> {
        const queryCommand = SharedFileService.createQueryCommand(filters);

        return this.handleRequest<IPagedData<UserSuggestion>>(
            this.http.get<IPagedData<UserSuggestion>>(`${this.url}/users`, {
                params: this.constructHttpParams(queryCommand)
            }),
            this.handlersFactory.getForReadByFilter()
        );
    }

    private static createQueryCommand(filters: {searchTerm: string, field: string}[]) {
        return <IQueryCommand>{
            filters: filters.map(filter => new StringFilter(filter.field, filter.searchTerm ?? "", StringFilterMatchMode.Contains))
        };
    }

    getFileUrl(id: string): Promise<any>{
        return this.handleRequest(
            this.http.get(`${this.url}/${id}/url`),
            this.handlersFactory.getDefault()
        );
    }
    
    checkFileAccess(id: string): Promise<any>{
        return this.handleRequest(
            this.http.get(`${this.url}/${id}/check-access`),
            this.handlersFactory.getDefault()
        );
    }

    addAccessHistoryToFile(id: string, sharing?: boolean): Promise<any> {
        const queryParams = sharing !== undefined ? `?sharing=${sharing}` : "";
        return this.handleRequest(this.http.post(`${this.url}/${id}/history-logging${queryParams}`, null), this.handlersFactory.getDefault());
    }      
    
}

